import { Card } from '@/components/ui/card';
import { useRepPace, type PaceTone } from '@/data/hooks/useRepPace';
import { TrendingUp, AlertTriangle, Check, Activity } from 'lucide-react';
import { cn } from '@/lib/utils';

const toneClass: Record<PaceTone, string> = {
  good: 'text-green-400 bg-green-500/10 border-green-500/20',
  warn: 'text-yellow-400 bg-yellow-500/10 border-yellow-500/20',
  bad: 'text-red-400 bg-red-500/10 border-red-500/20',
  neutral: 'text-muted-foreground bg-muted/40 border-border',
};

const toneIcon: Record<PaceTone, typeof Activity> = {
  good: Check,
  warn: TrendingUp,
  bad: AlertTriangle,
  neutral: Activity,
};

export function PaceStrip() {
  const chips = useRepPace();
  if (chips.length === 0) return null;
  return (
    <Card className="p-2">
      <div className="flex items-center gap-2 overflow-x-auto">
        {chips.map((c) => {
          const Icon = toneIcon[c.tone];
          return (
            <div
              key={c.key}
              className={cn(
                'flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border text-xs font-medium whitespace-nowrap',
                toneClass[c.tone],
              )}
            >
              <Icon className="h-3.5 w-3.5" />
              {c.label}
            </div>
          );
        })}
      </div>
    </Card>
  );
}